export default __webpack_public_path__ + "static/media/staffconnect.0c81d9ed.svg";